<template>
  <v-container>
    <v-row>
      <v-spacer></v-spacer>
      <RndNpc />
      <NewNpc />
    </v-row>
    <v-row justify="center">
      <v-hover v-for="npc in NPCs" :key="npc.id">
        <template v-slot:default="{ hover }">
          <v-card max-width="350" class="ma-4">
            <v-card-title class="title primary--text">{{npc.Name}}</v-card-title>
            <v-card-subtitle class="pb-0">Race: {{npc.Race}}</v-card-subtitle>
            <v-card-subtitle class="pt-0">{{npc.Description}}</v-card-subtitle>
            <v-card-subtitle class="pt-0">
              Related to :
              <span class="secondary--text">{{npc.Town.Name}}</span>
            </v-card-subtitle>

            <v-fade-transition>
              <v-overlay v-if="hover" absolute color="#036358">
                <v-btn class="primary" :to="{ name: 'NPC', params: { id: npc.id } }">See more info</v-btn>
              </v-overlay>
            </v-fade-transition>
          </v-card>
        </template>
      </v-hover>
    </v-row>
  </v-container>
</template>

<script>
import NewNpc from "@/components/NewNpc";
import RndNpc from "@/components/RndNpc";

import db from "@/fb";
import { store } from "@/fb";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "NPCs",
  data: () => ({
    NPCs: [],
  }),
  components: { NewNpc, RndNpc },

  firestore() {
    this.$bind(
      "NPCs",
      db
        .collection("npcs")
        .where("PlayerId", "==", firebase.auth().currentUser.uid)
        .where("CampaignId", "==", store.CurrentCampaign.id)
    );
  },
};
</script>
